import React from 'react';
import PageLinks from '../atom/PageLinks';
import SidebarBottomBanner from '../atom/SidebarBottomBanner';

import styles from './Sidebar.module.scss';

const Sidebar: React.FC = () => (
  <nav className={styles.sidebar}>
    <div className={styles.sidebar__inner}>
      <h1>
        <img
          src='https://contents.rals.biz/assets/common/img/rals/img_logo_rals.png'
          alt='株式会社ラルズネット'
          width='200'
        />
      </h1>
      <p className={styles.subtitle}>ホームページ制作カタログ</p>
      <PageLinks setPosition='sidebar' />
      <aside className={styles.sidebar__bottom}>
        <SidebarBottomBanner />
      </aside>
    </div>
  </nav>
);

export default Sidebar;
